import { render, staticRenderFns } from "./work_list.vue?vue&type=template&id=5da6ed5e&scoped=true"
import script from "./work_list.vue?vue&type=script&lang=js"
export * from "./work_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da6ed5e",
  null
  
)

export default component.exports